import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_PURCHASE_INVOICE_STATE,
  CLEAR_SINGLE_PURCHASE_INVOICE,
  defaultPurchaseInvoiceState,
  FETCH_PURCHASE_INVOICE_LIST_FAILED,
  FETCH_PURCHASE_INVOICE_LIST_PROGRESS,
  FETCH_PURCHASE_INVOICE_LIST_SUCCESS,
  FETCH_SINGLE_PURCHASE_INVOICE_FAILED,
  FETCH_SINGLE_PURCHASE_INVOICE_PROGRESS,
  FETCH_SINGLE_PURCHASE_INVOICE_SUCCESS,
  PurchaseInvoiceActions,
} from ".";

export const purchaseInvoiceReducer = (
  state: IStoreState["purchaseInvoice"] = defaultPurchaseInvoiceState,
  action: PurchaseInvoiceActions,
) => {
  switch (action.type) {
    case FETCH_PURCHASE_INVOICE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.purchase_invoice_list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_PURCHASE_INVOICE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.purchase_invoice_list.loading = LoadState.Loaded;
        draftState.purchase_invoice_list.list = data;
        draftState.purchase_invoice_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PURCHASE_INVOICE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.purchase_invoice_list.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_SINGLE_PURCHASE_INVOICE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.single_purchase_invoice.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_PURCHASE_INVOICE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_purchase_invoice.loading = LoadState.Loaded;
        draftState.single_purchase_invoice.data = data;
      });
      return newState;
    }
    case FETCH_SINGLE_PURCHASE_INVOICE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_purchase_invoice.loading = LoadState.Failed;
        draftState.single_purchase_invoice.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_SINGLE_PURCHASE_INVOICE: {
      const newState = produce(state, (draftState) => {
        draftState.single_purchase_invoice.loading = LoadState.NotLoaded;
        draftState.single_purchase_invoice.data =
          defaultPurchaseInvoiceState["single_purchase_invoice"]["data"];
        draftState.single_purchase_invoice.error =
          defaultPurchaseInvoiceState["single_purchase_invoice"]["error"];
      });
      return newState;
    }
    case CLEAR_PURCHASE_INVOICE_STATE: {
      return defaultPurchaseInvoiceState;
    }

    default: {
      return state;
    }
  }
};
